import { render, staticRenderFns } from "./staffForm.vue?vue&type=template&id=439c2bab&scoped=true"
import script from "./staffForm.vue?vue&type=script&lang=js"
export * from "./staffForm.vue?vue&type=script&lang=js"
import style0 from "./staffForm.vue?vue&type=style&index=0&id=439c2bab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439c2bab",
  null
  
)

export default component.exports